import styled from "styled-components";
import * as theme from '@zero/design-tokens/build/js/variables';

export const Rectangle = styled.div`
    border: solid 1px ${theme.ZrColorNeutralLight};
    border-radius: 1.5px;
    padding: 2px;
    margin: 10px 0;
`;

export const RectangleTitle = styled.h2`
    font-size: ${theme.ZrFontSizeXxxs};
    font-weight: ${theme.ZrFontWeightBold};
    margin-bottom:${theme.ZrSpacingVerticalXs};
    margin-top:${theme.ZrSpacingVerticalXs};
    color:${theme.ZrColorNeutralMedium02};
`;